var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "top-gifters"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.giftTitle')))]), _vm._v(" "), _c('div', {
    ref: "swiperContainer",
    staticClass: "swiper-custom-container board swiper-no-swiping"
  }, [_c('div', {
    staticClass: "swiper-pagination-static nav"
  }, [_c('div', {
    staticClass: "swiper-pagination-bullet-static daily",
    class: {
      selected: _vm.selected === 0
    },
    on: {
      "click": function click($event) {
        return _vm.slideTo(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.liveTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination-bullet-static nearby",
    class: {
      selected: _vm.selected === 1
    },
    on: {
      "click": function click($event) {
        return _vm.slideTo(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.totalTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_vm.hostid && _vm.videoid ? _c('top-gift-page', {
    ref: "topgiftpage0",
    attrs: {
      "hostid": _vm.hostid,
      "videoid": _vm.videoid,
      "actIndex": "0"
    },
    on: {
      "opencard": _vm.opencard
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm.hostid && _vm.videoid ? _c('top-gift-page', {
    ref: "topgiftpage1",
    attrs: {
      "hostid": _vm.hostid,
      "videoid": _vm.videoid,
      "actIndex": "1"
    },
    on: {
      "opencard": _vm.opencard
    }
  }) : _vm._e()], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };